import { render, staticRenderFns } from "./TableStatic.vue?vue&type=template&id=61c9cf46&scoped=true&"
import script from "./TableStatic.vue?vue&type=script&lang=js&"
export * from "./TableStatic.vue?vue&type=script&lang=js&"
import style0 from "./TableStatic.vue?vue&type=style&index=0&id=61c9cf46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c9cf46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLabel } from 'vuetify/lib/components/VLabel';
installComponents(component, {VDataTable,VLabel})
